import { Button } from '@mantine/core';
import React, { FC } from 'react';

import { ModalBody, ModalFooter } from '@portals/core';

import { FormComponentCommonProps } from './types';
import { VendorField } from './VendorField';

const VendorForm: FC<FormComponentCommonProps> = ({
  handleClose,
  selectedPartnerId,
  setSelectedPartnerId,
}) => {
  return (
    <>
      <ModalBody>
        <VendorField
          vendor={selectedPartnerId}
          setVendor={setSelectedPartnerId}
        />
      </ModalBody>
      <ModalFooter position="right">
        <Button type="button" variant="default" onClick={handleClose}>
          Cancel
        </Button>
        <Button type="submit" disabled>
          Claim device
        </Button>
      </ModalFooter>
    </>
  );
};

export default VendorForm;
